// Imported first by main.tsx: the token leaves the address bar before the router or anything else reads the URL.
import { takeBootToken, takeWantedTenant } from "./lib/session";

const { token, cleanUrl } = takeBootToken(window.location.href);
if (cleanUrl !== null) window.history.replaceState(window.history.state, "", cleanUrl);

export const bootToken = token;

const wanted = takeWantedTenant(window.location.href);
if (wanted.cleanUrl !== null) window.history.replaceState(window.history.state, "", wanted.cleanUrl);

export const wantedTenant = wanted.tenant;
